// X add to collection
// X figure out what's up with single sentence tts
// O error handling
// - add way more content
// - ensure free user works
// - free user add to collection click
import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

import { pctStr, secondsToMMSSStr, splitTextOnCloze } from "../helpers";

import ClozeSentence from "./ClozeSentence";
import CollectionSelector from "./CollectionSelector";
import Icon from "./Icon";
import Loading from "./Loading";
import Markdown from "./Markdown";
import Modal from "./Modal";
import Panel from "./Panel";
import ProgressBar from "./ProgressBar";

/**
 * Simple Bootstrap 3 audio player
 * Props:
 *  - src: string (mp3 URL)
 */
function AudioPlayer({ src }) {
  const audioRef = useRef(null);
  const progressRef = useRef(null);

  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);

  const percent = duration ? Math.min(100, (currentTime / duration) * 100) : 0;

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const onTimeUpdate = () => setCurrentTime(audio.currentTime || 0);
    const onLoaded = () => setDuration(audio.duration || 0);
    const onEnded = () => setIsPlaying(false);

    audio.addEventListener("timeupdate", onTimeUpdate);
    audio.addEventListener("loadedmetadata", onLoaded);
    audio.addEventListener("ended", onEnded);

    return () => {
      audio.removeEventListener("timeupdate", onTimeUpdate);
      audio.removeEventListener("loadedmetadata", onLoaded);
      audio.removeEventListener("ended", onEnded);
    };
  }, []);

  // Reset state when src changes
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    setIsPlaying(false);
    setCurrentTime(0);
    setDuration(0);
    audio.pause();
    audio.load();
  }, [src]);

  const toggle = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (isPlaying) {
      audio.pause();
      setIsPlaying(false);
    } else {
      audio.play();
      setIsPlaying(true);
    }
  };

  const onSeek = (e) => {
    const bar = progressRef.current;
    const audio = audioRef.current;
    if (!bar || !audio || !duration) return;

    const rect = bar.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const ratio = Math.max(0, Math.min(1, x / rect.width));
    const newTime = ratio * duration;
    audio.currentTime = newTime;
    setCurrentTime(newTime);
  };

  return (
    <div className="audio-player" style={{ alignItems: "center", display: "flex", flexDirection: "row", gap: 10 }}>
      <audio ref={audioRef} preload="metadata">
        <source src={src} type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>

      <div className="btn-group" role="group" aria-label="Audio controls">
        <button
          type="button"
          className="btn btn-lg btn-default"
          onClick={toggle}
          aria-label={isPlaying ? "Pause" : "Play"}
        >
          <Icon name={isPlaying ? "pause" : "play"} />
        </button>
      </div>

      <input type="range" min={0} max={duration} step={1} value={currentTime} onChange={(e) => { const audio = audioRef.current; audio.currentTime = e.target.value; setCurrentTime(e.target.value); }} style={{ width: 200 }} />
      {/*
      <div
        className="progress"
        ref={progressRef}
        onClick={onSeek}
        style={{ cursor: duration ? "pointer" : "default", height: 20, margin: 0, width: 200 }}
        aria-label="Seek"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(percent)}
      >
        <div
          className="progress-bar progress-bar-warning"
          style={{ width: `${percent}%` }}
        />
      </div>
      */}

      <div style={{ whiteSpace: "nowrap", width: 100 }}>{secondsToMMSSStr(Math.floor(currentTime))} / {secondsToMMSSStr(Math.floor(duration))}</div>
    </div>
  );
}

const AddDiscoverMediaClozeSentenceToCollection = ({ clozeSentence, collectionsUrl, onSave }) => {
  const [saving, setSaving] = useState(false);
  const [selectedCollection, setSelectedCollection] = useState(null);

  const save = () => {
    setSaving(true);
    $.ajax({
      data: { collection_id: selectedCollection.id },
      method: "post",
      url: clozeSentence.addToCollectionUrl
    })
      .done(() => {
        setSaving(false);
        onSave();
      })
      .fail(() => {
        alert("Failed to add to collection!");
      });
  };

  return (
    <Panel heading="Add to Collection" style={{ marginTop: 20 }}>
      <CollectionSelector
        collectionsUrl={collectionsUrl}
        onSelect={(collection) => {
          setSelectedCollection(collection);
        }}
      />
      <button className="btn btn-success" disabled={!selectedCollection || saving} onClick={save}>Save</button>
    </Panel>
  );
};

const PlayDiscoverMediaClozeSentence = ({ clozeSentence, collectionsUrl, index, isPro, onUpdate }) => {
  const [addToCollectionVisible, setAddToCollectionVisible] = useState(false);
  const [answered, setAnswered] = useState(clozeSentence.answered);
  const [explanationVisible, setExplanationVisible] = useState(false);
  const [savedToCollection, setSavedToCollection] = useState(false);
  const audioRef = useRef(null);

  const { preClozeStr, cloze, postClozeStr } = splitTextOnCloze(clozeSentence.text);
  const playable = isPro || index < 5;

  const toggleAnswer = () => {
    if(!playable) {
      return false;
    }
    setAnswered(!answered);
    $.ajax({
      method: answered ? "delete" : "post",
      url: clozeSentence.userClozeSentenceUrl
    })
      .done(() => {
        onUpdate({ ...clozeSentence, answered: !answered });
      })
      .fail(() => {
        alert("Failed to toggle answer!");
      });
  };

  return (
    <div className="panel panel-default" style={{ overflow: "visible", position: "relative" }}>
      <div className={`panel-body ${answered ? "bg-success" : ""}`} style={playable ? null : { filter: "blur(5px)", pointerEvents: "none" }}>
        {playable && <audio ref={audioRef} src={clozeSentence.ttsUrl} preload="none" />}
        <div style={{ marginBottom: 10 }}>
          <div style={{ fontSize: "1.5em" }}>{preClozeStr}<span onClick={toggleAnswer} style={{ cursor: "pointer" }}>{answered ? <strong><u>{cloze}</u></strong> : [...Array(cloze.length)].map(() => "_").join("")}</span>{postClozeStr}</div>
          <div>{clozeSentence.translation}</div>
        </div>
        <div style={{ alignItems: "center", display: "flex", gap: 10 }}>
          {playable ? (
            <>
              <button className={`btn btn-default btn-${answered ? "default" : "success"}`} onClick={toggleAnswer} style={{ width: 100 }}><Icon name="refresh" /> {answered ? "Hide" : "Show"}</button>
              <button className="btn btn-default" onClick={() => audioRef.current.paused ? audioRef.current.play() : audioRef.current.pause()}><Icon name="volume-up" /></button>
              {answered && (
                <>
                  <button className="btn btn-default" onClick={() => setExplanationVisible(!explanationVisible)}><Icon name={`chevron-${explanationVisible ? "up" : "down"}`} /> Explain</button>
                  <button className={`btn btn-default ${addToCollectionVisible ? "active" : ""}`} onClick={() => setAddToCollectionVisible(!addToCollectionVisible)}><Icon name="plus" /> Add to Collection</button>
                  {savedToCollection && <span>Saved!</span>}
                </>
              )}
            </>
          ) : (
            <>
              <button className={`btn btn-default btn-${answered ? "default" : "success"}`} disabled={true} style={{ width: 100 }}><Icon name="refresh" /> {answered ? "Hide" : "Show"}</button>
              <button className="btn btn-default" disabled={true}><Icon name="volume-up" /></button>
            </>
          )}
        </div>
        {addToCollectionVisible && (
          <AddDiscoverMediaClozeSentenceToCollection
            clozeSentence={clozeSentence}
            collectionsUrl={collectionsUrl}
            isPro={isPro}
            onSave={() => {
              setSavedToCollection(true);
              setAddToCollectionVisible(false);
            }}
          />
        )}
        {explanationVisible && (
          <div style={{ marginTop: 20 }}>
            <Panel>
              <Markdown>{clozeSentence.explanation}</Markdown>
            </Panel>
          </div>
        )}
      </div>
      {!isPro && index === 5 && (
        <div style={{ display: "flex", justifyContent: "center", left: 0, position: "absolute", right: 0, top: 60, zIndex: 999 }}>
          <div style={{ backgroundColor: "#000", borderRadius: 12, color: "#fff", padding: "50px 30px", width: "75%" }}>
            <p style={{ fontSize: "2em", fontWeight: "bold", marginBottom: 30, textAlign: "center" }}>Get full access to the rest of this content and get fluent faster with Clozemaster Pro.</p>
            <a className="btn btn-success btn-lg btn-block joystix" href="/pro">Get Pro today!</a>
          </div>
        </div>
      )}
    </div>
  );
}

const PlayDiscoverMedia = ({ collectionsUrl, discoverMedia, isPro }) => {
  const [clozeSentences, setClozeSentences] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [ttsUrl, setTtsUrl] = useState(null);

  useEffect(() => {
    $.ajax({
      url: discoverMedia.url
    })
      .done((data) => {
        const { discoverMedia } = data;
        const { clozeSentences, ttsUrl } = discoverMedia;
        console.log("clozeSentences", clozeSentences);
        setClozeSentences(clozeSentences);
        setTtsUrl(ttsUrl);
        setLoaded(true);
      })
      .fail(() => {
        alert("Failed to load sentences!");
      });
  }, []);

  const content = loaded ? (
    <>
      {clozeSentences.map((clozeSentence, index) => (
        <PlayDiscoverMediaClozeSentence
          clozeSentence={clozeSentence}
          collectionsUrl={collectionsUrl}
          index={index}
          isPro={isPro}
          onUpdate={(clozeSentence) => setClozeSentences(clozeSentences.map((cs) => cs.id === clozeSentence.id ? clozeSentence : cs))}
        />
      ))}
      {ReactDOM.createPortal(
        (
          <div style={{ alignItems: "center", bottom: 15, display: "flex", flexDirection: "column", justifyContent: "center", height: 0, left: 0, position: "fixed", right: 0, zIndex: 1050 }}>
            <div style={{ backgroundColor: "rgba(214, 214, 214, 0.9)", borderRadius: 10, boxShadow: "rgb(221, 221, 221) 3px 3px 10px", marginBottom: 80, padding: 10 }}>
              <AudioPlayer src={ttsUrl} />
              <div style={{ textAlign: "center" }}>
                {clozeSentences.filter((cs) => cs.answered).length} / {clozeSentences.length} answered ({pctStr(clozeSentences.filter((cs) => cs.answered).length, clozeSentences.length)})
              </div>
            </div>
          </div>
        ),
        document.querySelector("body")
      )}
    </>
  ) : <Loading />;

  return (
    <>
      <h1 style={{ marginTop: 0 }}>
        {discoverMedia.title}
        <br />
        <small>{discoverMedia.titleTranslation}</small>
      </h1>
      {content}
    </>
  );
};

export default function Discover({ collectionsUrl, isPro, url }) {
  const [currentMedia, setCurrentMedia] = useState(null);
  const [difficulties, setDifficulties] = useState([]);
  const [groupedDiscoverMedias, setGroupedDiscoverMedias] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [mediaTypes, setMediaTypes] = useState([]);

  useEffect(() => {
    $.ajax({
      url
    })
      .done((data) => {
        console.log("data", data);
        const {
          difficulties,
          groupedDiscoverMedias,
          mediaTypes
        } = data;
        setDifficulties(difficulties);
        setGroupedDiscoverMedias(groupedDiscoverMedias);
        setMediaTypes(mediaTypes);
        setLoaded(true);
      })
      .fail(() => {
        alert("Failed to load media!");
      });
  }, []);

  const content = loaded ? (
    <>
      {groupedDiscoverMedias.map((g) => (
        <div>
          <h1 style={{ fontWeight: "bold" }}>{g.pluralizedName}</h1>
          {difficulties.map((d) => (
            <>
              <h3>{d}</h3>
              <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: 15 }}>
                {g.discoverMedias.filter((m) => m.difficulty === d).map((m) => (
                  <div className="panel panel-default" style={{ display: "flex", flexDirection: "column", minHeight: 250, width: 250 }}>
                    <div className="panel-body" style={{ display: "flex", flex: 1, flexDirection: "column" }}>
                      <div style={{ flex: 1 }}>
                        <div><span className="label label-default" style={{ marginBottom: 5 }}>{m.difficulty}</span></div>
                        <div><span className="label label-default">{m.genre}</span></div>
                        <h4>
                          {m.title}
                          <br />
                          <small>{m.titleTranslation}</small>
                        </h4>
                      </div>
                      <div>{m.clozeSentencesCount} sentences</div>
                      <ProgressBar percent={m.userClozeSentencesCount / m.clozeSentencesCount * 100} />
                      <button className="btn btn-block btn-success joystix" disabled={!m.clozeSentencesCount} onClick={() => setCurrentMedia(m)}>{m.clozeSentencesCount ? "Play" : "Soon!"}</button>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ))}
        <hr />
        </div>
      ))}
    </>
  ) : <Loading />;

  return (
    <>
      <h1 style={{ fontFamily: "joystix" }}>Discover</h1>
      <p>Play through different media to learn with even more context. Add the sentences you want to learn to your custom collections.</p>
      {content}
      {currentMedia && (
        <Modal
          onHidden={() => setCurrentMedia(null)}
          size="large"
          title={currentMedia.mediaType}
        >
          <PlayDiscoverMedia
            collectionsUrl={collectionsUrl}
            discoverMedia={currentMedia}
            isPro={isPro}
          />
        </Modal>
      )}
    </>
  );
}
